import { isFedRamp } from '@atlassian/atl-context';

// https://sentry.io/settings/atlassian-2y/projects/people-and-teams-directory/keys/
export var SENTRY_PUBLIC_KEY = '1dc056d49dfe4df8961dc1b810e4620d';
export var SENTRY_PROJECT_ID = '5988845';
var SENTRY_COMMERCIAL_DSN = "https://".concat(SENTRY_PUBLIC_KEY, "@o55978.ingest.sentry.io/").concat(SENTRY_PROJECT_ID);
var SENTRY_FEDRAMP_DSN = "https://".concat(SENTRY_PUBLIC_KEY, "@sentry.atlassian-us-gov-mod.com/").concat(SENTRY_PROJECT_ID);
export var SENTRY_DSN = isFedRamp() ? SENTRY_FEDRAMP_DSN : SENTRY_COMMERCIAL_DSN;